export const zIndices = {
  high: 5,
  higher: 10,
  highest: 100000,
  overlay: 5300,
  modal: 5400,
};
